import { Autocomplete, Box, TextField } from '@mui/material'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import { useAppSelector } from 'redux/Hook'
import { setToolBuilder } from 'redux/slices/ToolBuilder'
import { fetchAdministratorEmails } from 'redux/thunks/ToolBuilder'

interface AdminEmailsProps {
  id: string
  label: string
  allowCustomEmails: boolean
  required?: boolean
}

const AdminEmails = (props: AdminEmailsProps) => {
  const { id, label, required, allowCustomEmails = true } = props
  const adminEmails = useAppSelector(
    (state) => state.toolBuilder.lookups?.adminEmails,
  )
  const { t } = useTranslation()
  const errorMessage = useAppSelector(
    (state) => state.toolBuilder.validation?.[id],
  )
  const value =
    useAppSelector((state) => state.toolBuilder?.toolBuilder?.[id]) || []

  useEffect(() => {
    dispatch(fetchAdministratorEmails())
  }, [])

  const dispatch = useDispatch()

  const filterOptions = (options: string[], { inputValue }: any) => {
    if (allowCustomEmails) {
      const filteredOptions = options.filter((opt) => opt?.includes(inputValue))

      // Improved regex: does not allow leading protocols or whitespace
      const EMAIL_REGEX =
        /^(?!.*:\/\/)[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/

      if (
        inputValue !== '' &&
        !filteredOptions.includes(inputValue) &&
        EMAIL_REGEX.test(inputValue)
      ) {
        filteredOptions.push(inputValue)
      }
      return filteredOptions
    }
    return options
  }

  return (
    <Box>
      <Autocomplete
        id={id}
        options={adminEmails ?? []}
        onChange={(event, newValue) => {
          dispatch(setToolBuilder({ name: id, value: newValue }))
        }}
        value={value}
        multiple={true}
        filterOptions={filterOptions}
        getOptionLabel={(option: any) => option || ''}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label={label}
            required={required}
            error={!!errorMessage}
            helperText={errorMessage}
          />
        )}
        noOptionsText={t('toolBuilder.noOptionsText')}
      />
    </Box>
  )
}

export default AdminEmails
